import { ARTICLES } from "../data.js";

// Écran Profil (todo.md, P2) : nom affiché (profiles.display_name, créé par
// le trigger handle_new_user mais jusqu'ici jamais modifiable depuis l'UI)
// + vue agrégée de tous les favoris et de toutes les notes — jusqu'ici
// aucun endroit ne montrait plus qu'une fiche à la fois. Fonctionne aussi
// hors connexion : les favoris/notes existent déjà en mémoire/localStorage
// pour un invité, cet écran ne fait que les lister.
export function buildProfileView(ctx) {
  const { s, patch, go, user, saveProfileName } = ctx;

  const bookmarkRows = Object.keys(s.bookmarks)
    .filter((id) => s.bookmarks[id])
    .map((id) => ARTICLES.find((a) => a.id === id))
    .filter(Boolean)
    .sort((a, b) => a.title.localeCompare(b.title, "fr"))
    .map((a) => ({ title: a.title, domain: a.domain, onClick: () => go(a.id) }));

  const noteRows = Object.keys(s.notes)
    .filter((id) => s.notes[id] && s.notes[id].trim())
    .map((id) => ({ id, art: ARTICLES.find((a) => a.id === id), body: s.notes[id] }))
    .filter((r) => r.art)
    .sort((a, b) => a.art.title.localeCompare(b.art.title, "fr"))
    .map((r) => ({
      title: r.art.title,
      excerpt: r.body.trim().slice(0, 140) + (r.body.trim().length > 140 ? "…" : ""),
      wordCount: r.body.trim().split(/\s+/).filter(Boolean).length,
      onClick: () => patch({ screen: "article", articleId: r.id, articleTab: "notes" }),
    }));

  return {
    profileEmail: user ? user.email : "",
    profileSignedIn: !!user,
    profileName: s.profileName,
    onProfileName: (e) => patch({ profileName: e.target.value }),
    saveProfileName: () => saveProfileName(s.profileName),
    bookmarkRows, bookmarkCount: bookmarkRows.length,
    noteRows, noteCount: noteRows.length,
  };
}
